export class AirPackModel {
    lenght: number;
    width: number;
    height: number;
    perKg: number;
    lineVolume: number;
    pieces: number;
    packing: string;
    totalWeight: number;
}